import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-the-simple-header" }
const _hoisted_2 = { class: "p-the-simple-header" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-simple-header__col" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "p-the-simple-header__header",
        style: _normalizeStyle({ borderColor: _ctx.colorCode })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: _ctx.isAdminSite ? '/dashboard/' : '/home/',
              class: "p-the-simple-header__logo",
              style: _normalizeStyle(_ctx.serviceLogoStyle)
            }, [
              _createElementVNode("img", {
                src: _ctx.serviceLogo,
                alt: _ctx.serviceName
              }, null, 8, _hoisted_6)
            ], 12, _hoisted_5)
          ])
        ])
      ], 4)
    ])
  ]))
}